import { IModalDescription, IModalProps, ViewVariant } from '@cp/shared/modal/manager.interface';
import { OrderNannyFormProps, SuccessOrderModal } from '../model/orderNanny';
import { CatalogItemResponseProps } from '../model/responseVacancy';

export const ORDER_NANNY_MODAL: IModalDescription<OrderNannyFormProps> = {
  nss: 'orderNanny',
  loader: () => import('../ui/OrderNannyModal').then((module) => module.OrderNannyModal),
  layout: {
    desktop: ViewVariant.DrawerRight,
    mobile: ViewVariant.Fullscreen,
  },
};

export const SUCCESS_ORDER_MODAL: IModalDescription<SuccessOrderModal> = {
  nss: 'SuccesOrderNanny',
  loader: () => import('../ui/OrderNannySuccess').then((module) => module.OrderNannySuccess),
  layout: {
    desktop: ViewVariant.Dialog,
    mobile: ViewVariant.DrawerBottom,
  },
};

export const PRICE_VACANCY_MODAL: IModalDescription<CatalogItemResponseProps> = {
  nss: 'PRICE_VACANCY_MODAL',
  loader: () => import('../ui/ResponseVacancyModal').then((module) => module.ResponseVacancyModal),
  layout: {
    desktop: ViewVariant.Dialog,
    mobile: ViewVariant.DrawerBottom,
  },
};

export const VACANCY_SUCCESS_MODAL: IModalDescription<IModalProps> = {
  nss: 'VACANCY_SUCCESS_MODAL',
  loader: () => import('../ui/ResponseVacancySuccess').then((module) => module.ResponseVacancySuccess),
  layout: {
    desktop: ViewVariant.Dialog,
    mobile: ViewVariant.DrawerBottom,
  },
};
